// extracted by mini-css-extract-plugin
module.exports = {"likesWrapper":"_c084098f","noHover":"_c8cae403"};